import { createFileRoute } from "@tanstack/react-router";

import { SellersPage } from "../../../../areas/admin/sellers/SellersPage";

export const Route = createFileRoute("/app/_seller/admin/sellers")({
  component: SellersPage,
});
